import { useMemo } from "react"

import type { Locale } from "date-fns"
import { da, de, enUS, nb, sv } from "date-fns/locale"
import { useTranslation } from "react-i18next"

const LOCALE_MAP: Record<string, Locale> = {
  sv,
  en: enUS,
  nb,
  da,
  de,
}

const getLocaleForLanguage = (language: string): Locale => {
  // Extract base language code (e.g., "en" from "en-US" or "en_US")
  const baseLanguage = language.split(/[-_]/)[0].toLowerCase()
  return LOCALE_MAP[baseLanguage] || sv
}

const useDateLocale = (): Locale => {
  const { i18n } = useTranslation()

  const loc = useMemo(
    () => getLocaleForLanguage(i18n.language),
    [i18n.language]
  )
  loc.options = { ...loc.options, weekStartsOn: 1 }

  return loc
}

export default useDateLocale
